import HeroSection from "@/components/home/HeroSection";
import ProblemSection from "@/components/home/ProblemSection";
import WhereRiskSection from "@/components/home/WhereRiskSection";
import WhatWeDoSection from "@/components/home/WhatWeDoSection";
import CaseNarrativeSection from "@/components/home/CaseNarrativeSection";
import AudienceSection from "@/components/home/AudienceSection";
import CoreQuestionSection from "@/components/home/CoreQuestionSection";
import { DotJourneyPath } from "@/components/AboriginalPatterns";

const Index = () => {
  return (
    <div className="bg-background">
      <HeroSection />

      <div className="px-6 opacity-50">
        <DotJourneyPath className="text-primary" />
      </div>

      <ProblemSection />
      <WhereRiskSection />
      <WhatWeDoSection />

      <div className="px-6 opacity-40">
        <DotJourneyPath className="text-ochre" />
      </div>

      <CaseNarrativeSection />
      <AudienceSection />
      <CoreQuestionSection />
    </div>
  );
};

export default Index;
